
import { computed, defineAsyncComponent, defineComponent } from 'vue'
import { mapState } from 'vuex'
import { AttachmentType, LabelType, MemberType } from '@/types/entities'
import KanbanTaskLabel from '@/components/KanbanTaskLabel.vue'
import AvatarGroup from '@/components/AvatarGroup.vue'

export default defineComponent({
  components: {
    KanbanTaskLabel,
    AvatarGroup,
    KanbanTaskModal: defineAsyncComponent(
      () => import(/* webpackChunkName: "TaskModal" */ '@/components/KanbanTaskModal.vue')
    )
  },
  props: {
    task: {
      type: Object,
      required: true
    }
  },
  provide () {
    return {
      task: computed(() => this.task),
      cover: computed(() => this.cover),
      taskMembers: computed(() => this.taskMembers),
      taskLabels: computed(() => this.taskLabels)
    }
  },
  inject: ['list'],
  computed: {
    ...mapState({
      currentBoard: 'currentBoard'
    }),
    taskMembers () {
      return this.currentBoard.members.filter((mem: MemberType) => this.task.members.includes(mem._id))
    },
    taskLabels () {
      return this.currentBoard.labels.filter((label: LabelType) => this.task.labels.includes(label._id))
    },
    cover () {
      return this.task.attachments.find((att: AttachmentType) => att.isCover)
    }
  },
  data () {
    return {
      showModal: false,
      showEditIcon: false,
      squeezeLbls: false
    }
  },
  methods: {
    handleDragStart (e: DragEvent) {
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', JSON.stringify({ listId: this.list._id, taskId: this.task._id }))
    },
    formatDate (date: string) {
      return new Intl.DateTimeFormat('en', { month: 'short', day: 'numeric' }).format(new Date(date))
    }
  }
})
